// Module
var code = "<div class=\"br-caption-2 text-ellipsis\" ng-style=\"{background: $ctrl.color}\"> <span>{{$ctrl.name}}</span> <md-tooltip md-delay=\"500\">{{$ctrl.name}}</md-tooltip> </div> ";
// Exports
export default code;